import React from 'react';
import wavesImg from '../assets/waves.png';

const TechWaves = () => {
  return (
    <>
      <style>{`
        .waves-wrapper {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
          z-index: 0;
          pointer-events: none;
        }

        .wave-layer {
          position: absolute;
          bottom: -10%;
          left: -10%;
          width: 120%;
          height: 120%;
          background-image: url(${wavesImg});
          background-size: cover;
          background-position: center bottom;
          background-repeat: no-repeat;
        }

        .wave-1 {
          opacity: 0.5;
          animation: fluidRipple1 12s ease-in-out infinite alternate;
        }

        .wave-2 {
          opacity: 0.3;
          animation: fluidRipple2 18s ease-in-out infinite alternate;
          mix-blend-mode: screen;
        }
        
        .wave-3 {
          opacity: 0.2;
          animation: fluidRipple3 24s ease-in-out infinite alternate;
          mix-blend-mode: screen;
        }

        @keyframes fluidRipple1 {
          0% { transform: scale(1) translate(0px, 0px) rotate(0deg); }
          50% { transform: scale(1.05) translate(-1%, 2%) rotate(0.5deg); }
          100% { transform: scale(1.1) translate(1%, -1%) rotate(-0.5deg); }
        }

        @keyframes fluidRipple2 {
          0% { transform: scale(1.1) translate(1%, -2%) rotate(-0.5deg); }
          50% { transform: scale(1.05) translate(0%, 1%) rotate(0deg); }
          100% { transform: scale(1) translate(-1%, 2%) rotate(0.5deg); }
        }
        
        @keyframes fluidRipple3 {
          0% { transform: scale(1.05) translate(-1%, 1%) rotate(0.5deg); }
          50% { transform: scale(1.1) translate(1%, -1%) rotate(-0.5deg); }
          100% { transform: scale(1) translate(0px, 0px) rotate(0deg); }
        }

        @media (max-width: 768px) {
          .wave-layer {
            width: 220%;
            height: 140%;
            left: -60%;
            bottom: -20%;
            background-size: cover;
            background-position: 72% bottom;
          }

          .wave-1 {
            opacity: 0.75;
          }

          .wave-2 {
            opacity: 0.5;
          }
          
          .wave-3 {
            opacity: 0.35;
          }
        }
      `}</style>
      <div className="waves-wrapper">
        <div className="wave-layer wave-1"></div>
        <div className="wave-layer wave-2"></div>
        <div className="wave-layer wave-3"></div>
      </div>
    </>
  );
};

export default TechWaves;
